import * as web3 from "@solana/web3.js";
import * as ed25519 from "ed25519-hd-key";
import { Buffer } from "buffer";
import { VMType } from "@orb-labs/types";
export class Solana {
    static getSolanaKeyPair(seedHex, derivationPath) {
        const privateKey = ed25519.derivePath(derivationPath, seedHex).key;
        return web3.Keypair.fromSeed(privateKey);
    }
    static serializeInstruction(inst) {
        return {
            keys: inst.keys.map((key) => {
                return {
                    pubkey: key.pubkey.toString(),
                    isSigner: key.isSigner,
                    isWritable: key.isWritable,
                };
            }),
            programId: inst.programId.toString(),
            data: inst.data.toString("base64"),
        };
    }
    static async getKeypair(data) {
        return Solana.getSolanaKeyPair(Buffer.from(data.seed.data).toString("hex"), this.getDerivationPath(data.accountIdx));
    }
    async deriveAddress(data) {
        const solanaPublicKey = new web3.PublicKey(Buffer.from(data.extendedPublicKey));
        return solanaPublicKey.toString();
    }
    async deriveAllAddresses(data) {
        return [await this.deriveAddress(data)];
    }
    static getDerivationPath(accountIdx) {
        return `m/44'/501'/${accountIdx ?? 0}'/0'`;
    }
    static getWalletAccountConfig(accountIdx) {
        return {
            curve: "CURVE_ED25519",
            addressFormat: "ADDRESS_FORMAT_SOLANA",
            pathFormat: "PATH_FORMAT_BIP32",
            path: this.getDerivationPath(accountIdx),
        };
    }
    isAddressValid(address) {
        try {
            return Boolean(new web3.PublicKey(address));
        }
        catch (_) {
            return false;
        }
    }
    /**
     * Parse a Solana Pay URI.
     *
     * @see https://docs.solanapay.com/spec
     */
    static parseUri(uri) {
        const withoutScheme = uri.replace(/^solana:/i, "");
        const [address, queryString] = withoutScheme.split("?");
        const params = new URLSearchParams(queryString || "");
        const amount = params.get("amount") ?? undefined;
        const tokenAddress = params.get("spl-token") ?? undefined;
        return {
            vmType: VMType.SVM,
            address,
            amount,
            tokenAddress,
        };
    }
}
